var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
if (!customElements.get("ona-tablist")) {
  class OnaTabList extends HTMLElement {
    constructor() {
      super();
      this._handleTabChange = this._handleTabChange.bind(this);
    }
    connectedCallback() {
      this.setAttribute("role", "tablist");
      this._tabs = this.querySelectorAll("ona-tab");
      this._tabs.forEach((tab) => {
        tab.addEventListener("select", this._handleTabChange);
      });
    }
    _handleTabChange(e) {
      this.dispatchEvent(new CustomEvent("change", { detail: { currentTab: e.target } }));
    }
  }
  customElements.define("ona-tablist", OnaTabList);
  class OnaTab extends HTMLElement {
    constructor() {
      super();
      this.setAttribute("role", "tab");
      this.setAttribute("tabindex", "-1");
      this.addEventListener("click", this._onClick.bind(this));
      this.addEventListener("keydown", this._onKeyDown.bind(this));
    }
    connectedCallback() {
      if (!this.id) {
        console.warn("<ona-tab> needs an ID to work correctly with aria-labelledby/controls");
        return;
      }
      this._updateState();
      const tablist = this.closest("ona-tablist");
      const root = tablist == null ? void 0 : tablist.parentElement;
      if (root) {
        const panels = root.querySelectorAll("ona-tabpanel");
        panels.forEach((panel) => {
          const labelledBy = panel.getAttribute("aria-labelledby");
          if (labelledBy === this.id) {
            if (!panel.id) panel.id = `panel-${this.id}`;
            this.setAttribute("aria-controls", panel.id);
          }
        });
      }
    }
    attributeChangedCallback(name) {
      if (name === "selected") {
        this._updateState();
      }
    }
    _updateState() {
      const selected = this.hasAttribute("selected");
      this.setAttribute("aria-selected", selected ? "true" : "false");
      this.setAttribute("tabindex", selected ? "0" : "-1");
    }
    _onClick() {
      this._select();
    }
    _onKeyDown(e) {
      const isHorizontal = true;
      const tabs = Array.from(this.parentElement.querySelectorAll("ona-tab"));
      const currentIndex = tabs.indexOf(this);
      let newIndex = currentIndex;
      if (isHorizontal) {
        if (e.key === "ArrowRight") newIndex = (currentIndex + 1) % tabs.length;
        if (e.key === "ArrowLeft") newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else {
        if (e.key === "ArrowDown") newIndex = (currentIndex + 1) % tabs.length;
        if (e.key === "ArrowUp") newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      }
      if (newIndex !== currentIndex) {
        tabs[newIndex].focus();
        tabs[newIndex]._select();
      }
    }
    _select() {
      const tablist = this.closest("ona-tablist");
      const tabs = tablist.querySelectorAll("ona-tab");
      const panels = tablist.parentElement.querySelectorAll("ona-tabpanel");
      tabs.forEach((tab) => tab.removeAttribute("selected"));
      this.setAttribute("selected", "");
      this.dispatchEvent(new CustomEvent("select"));
      panels.forEach((panel) => {
        const isMatch = panel.getAttribute("aria-labelledby") === this.id;
        panel.hidden = !isMatch;
      });
    }
  }
  __publicField(OnaTab, "observedAttributes", ["selected"]);
  customElements.define("ona-tab", OnaTab);
  class OnaTabPanel extends HTMLElement {
    connectedCallback() {
      this.setAttribute("role", "tabpanel");
      const labelledBy = this.getAttribute("aria-labelledby");
      if (!labelledBy) {
        console.warn("<ona-tabpanel> requires aria-labelledby pointing its <ona-tab> ID");
        return;
      }
      if (!this.id) {
        this.id = `panel-${labelledBy}`;
      }
    }
    get tabElement() {
      return document.getElementById(this.getAttribute("aria-labelledby"));
    }
  }
  customElements.define("ona-tabpanel", OnaTabPanel);
}
